import { render, staticRenderFns } from "./ObjectStaticMap.vue?vue&type=template&id=589b9402&scoped=true&"
import script from "./ObjectStaticMap.vue?vue&type=script&lang=js&"
export * from "./ObjectStaticMap.vue?vue&type=script&lang=js&"
import style0 from "./ObjectStaticMap.vue?vue&type=style&index=0&id=589b9402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589b9402",
  null
  
)

export default component.exports